<template>
    <v-main>
      <head>
        <title>Foraje -- Blog</title>
        <meta name="description" content="Foraje's Official Blog, containing articles about interesting varieties, and the people who care about them. Also often has tech-focused dev updates.">
      </head>
        <v-container  v-if="latestblogpost">
          <v-row   v-if="issomethingloading && !latestblogpost.length">
            <v-col cols="12" class="text-center">
              <v-progress-circular
                      :size="100"
                      :width="7"
                      color="primary"
                      indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>
          <v-row   justify="center" class="my-5" v-else>
            <v-col cols="12" sm="8">
              <v-card flat class="transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div>
                    <div class="headline justify-center">{{latestblogpost.title}}</div>
                    <div class=" grey--text text-lg-center" v-if="latestblogpost.subtitle">{{latestblogpost.subtitle}}</div>
                  </div>
                </v-card-title>
              </v-card>
            </v-col>
            <v-col cols="12" sm="10">

                    <v-subheader style="justify-content: right">
                      <v-card flat>
                        <v-avatar>
                          <v-img
                            :src="latestblogpost.author.profile_image.image.medium_square_crop"
                            :lazy-src="latestblogpost.author.profile_image.image.small_square_crop"
                            class="elevation-1 ProfilePicture"
                            v-if="latestblogpost.author.profile_image && latestblogpost.author.profile_image.image"
                          >
                          </v-img>
                          <v-img v-else src="https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg" class="ProfilePicture elevation-1">
                          </v-img>
                        </v-avatar>
                        <router-link :to="'/profiles/' + latestblogpost.author.slug">{{latestblogpost.author.display_name}}</router-link>
                      </v-card>
                    </v-subheader>
            </v-col>
            <v-col cols="12" sm="8" v-if="compiledMarkdownBlogPost">
              <v-card >
                <v-card-text>
                  <div v-html="compiledMarkdownBlogPost" class="ma-3"></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
<v-divider></v-divider>

      <<!--v-container  v-if="authorsotherblogposts && authorsotherblogposts.length">
        <h2>Other Posts By <router-link :to="'/profiles/' + latestblogpost.author.slug">{{latestblogpost.author.display_name}}</router-link></h2>
        <v-row >
          <v-col cols="12" sm="4" v-for="authorsotherblogpost of authorsotherblogposts" :key="authorsotherblogpost.id">
            <v-card hover :to="'/blog/posts/' + authorsotherblogpost.slug">
              <v-card-title primary-title>
                <div class="cardTitle">
                  <h3 align="center">{{authorsotherblogpost.title}}</h3>
                  <p class="text-center grey&#45;&#45;text" v-if="authorsotherblogpost.subtitle">{{authorsotherblogpost.subtitle}}</p>
                </div>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <v-container  v-if="generalotherblogposts && generalotherblogposts.length">
        <h2>Other Posts</h2>
        <v-row >
          <v-col cols="12" sm="4" v-for="generalotherblogpost of generalotherblogposts" :key="generalotherblogpost.id">
            <v-card hover :to="'/blog/posts/' + generalotherblogpost.slug">
              <v-card-title primary-title>
                <div class="cardTitle">
                  <h3 align="center">{{generalotherblogpost.title}}</h3>
                  <p class="text-center grey&#45;&#45;text" v-if="generalotherblogpost.subtitle">{{generalotherblogpost.subtitle}}</p>
                </div>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>-->


    </v-main>
</template>

<script>
import axios from 'axios';
import marked from 'marked';
import DOMPurify from 'dompurify';

export default {
  name: 'BlogLandingPage',
  data: () => ({

    latestblogpost: [],
    generalotherblogposts: [],
    authorsotherblogposts: [],
    errors: [],
    generalblogpostpageCount: 1,
    authorsblogpostpageCount: 1,
    issomethingloading: false,
    generalotherblogpostsfullresponse: [],
    authorsotherblogpostsfullresponse: [],
  }),

  methods: {
    GetLatestPost() {
      this.issomethingloading = true;
      axios.get('content/blogs/posts/most-recent/')
        .then((response) => {
          // JSON responses are automatically parsed.
          this.latestblogpost = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .then(() => {
          this.GetAuthorsOtherPosts();
        })
        .then(() => {
          this.GetGeneralOtherPosts();
        })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
    GetGeneralOtherPosts() {
      this.issomethingloading = true;
      return axios.get(`${'content/blogs/posts/all/?page='}${this.generalblogpostpageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.generalotherblogposts = response.data.results;
          this.generalotherblogpostsfullresponse = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
    GetAuthorsOtherPosts() {
      const authorSlug = this.latestblogpost.author.slug;
      this.issomethingloading = true;
      return axios.get(`content/blogs/posts/by/author/${authorSlug}/?page=${this.authorsblogpostpageCount}`)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.authorsotherblogposts = response.data.results;
          this.authorsotherblogpostsfullresponse = response.data;
        })
        .then(() => { this.issomethingloading = false; })
        .catch((e) => {
          this.errors.push(e);
          this.issomethingloading = false;
        });
    },
    GeneralBlogPostsLoadNextBatch() {
      if (this.generalotherblogpostsfullresponse.next != null) {
        this.generalblogpostspageCount += 1;
        this.GetGeneralOtherPosts();
      }
    },

    GeneralBlogPostsLoadPreviousBatch() {
      this.generalblogpostspageCount -= 1;
      this.GetGeneralOtherPosts();
    },
    AuthorsBlogPostsLoadNextBatch() {
      if (this.authorsotherblogpostsfullresponse.next != null) {
        this.authorsblogpostspageCount += 1;
        this.GetAuthorsOtherPosts();
      }
    },

    AuthorsBlogPostsLoadPreviousBatch() {
      this.authorsblogpostspageCount -= 1;
      this.GetAuthorsOtherPosts();
    },
  },
  computed: {
    compiledMarkdownBlogPost() {
      return DOMPurify.sanitize(marked(this.latestblogpost.post));
    },
  },

  created() {
    // Not super elegant, but hey, it works.
    this.GetLatestPost();
  },

};
</script>

<style scoped>
.otherPostsSummary{
  word-break: break-word;
}
  .cardTitle{
    width: 100%;
  }
.FetchedThumbail{
  border-radius: 50%;
}
.ProfilePicture{
  border-radius: 50%;
}
</style>
